import type { ConfigItem } from '@/services/lookupService';

const STORAGE_KEY = 'system_config';

/**
 * Persists the full system config to localStorage as a flat key→value map.
 * Called automatically by useSystemConfig after every successful fetch.
 */
export function setSystemConfig(items: ConfigItem[]): void {
  const map: Record<string, string> = {};
  for (const item of items) {
    if (item.value !== null) map[item.key] = item.value;
  }
  localStorage.setItem(STORAGE_KEY, JSON.stringify(map));
}

/**
 * Synchronously reads a single config value from localStorage.
 * Returns undefined if the key is absent or the store hasn't been populated yet.
 */
export function getSystemConfig(key: string): string | undefined {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return undefined;
    const map = JSON.parse(raw) as Record<string, string>;
    return map[key];
  } catch {
    return undefined;
  }
}
